import React from "react";
import { SubmitButton,  SelectForm } from "components";
import { VideoVisibilityEnum } from "props/enum";

interface FormProps {
  loading: boolean;
  visibility: string;
  handleChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  handleSubmit?: React.MouseEventHandler<HTMLButtonElement>;
}

export const VideoVisibilityForm: React.FC<FormProps> = ({
  visibility,
  handleChange,
  handleSubmit,
  loading,
}) => {
  return (
    <form>
      <h2 className="text-xl font-bold my-3">Update Video Visibility</h2>
      <div className="pb-3">
        <SelectForm
          label="Video Visibility"
          id="visibility"
          name="visibility"
          value={visibility}
          option={Object.values(VideoVisibilityEnum).map((value) => (
            <option key={value} value={value}>
              {value}
            </option>
          ))}
          onChange={handleChange}
        />
      </div>
      <SubmitButton loading={loading} onClick={handleSubmit} />
    </form>
  );
};
